<template>
  <section>
    <div class="header mb-1 p-0 md:p-2 ml-8 md:ml-0">
      <h2 class="font-bold text-gray-700 text-xl">
        <i class="bx bxs-user-rectangle text-indigo-500 -m-8 mr-1"></i>
        INFORMAÇÕES PESSOAIS
      </h2>
      <small class="text-gray-600">Para quem devemos entregar o pedido?</small>
    </div>
    <div class="p-0 md:p-1 mb-1">
      <ValidationProvider rules="required|nome" v-slot="{ errors }">
        <t-input
          name="my-input"
          :variant="errors.length > 0 ? 'danger' : '' "
          class="w-full"
          placeholder="Nome completo:"
          v-model="customer_name"
        />
        <span class="text-red-500 block pt-1" v-if="errors.length">
          <i class="bx bx-error mr-1"></i>
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="p-0 md:p-1 md:pb-0 mb-1">
      <ValidationProvider rules="required|email" v-slot="{ errors }">
        <t-input
          name="my-input"
          :variant="errors.length > 0 ? 'danger' : '' "
          class="w-full"
          placeholder="E-mail:"
          v-model="customer_email"
        />
        <span class="text-red-500 block pt-1" v-if="errors.length">
          <i class="bx bx-error mr-1"></i>
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="flex flex-wrap">
      <input type="hidden" id="docType" name="docType" data-checkout="docType" value="CPF">
      <div class="w-full lg:w-2/4 mb-1 p-0 md:p-1 md:pb-0">
        <ValidationProvider rules="required|cpf" v-slot="{ errors }">
          <t-input
            name="docNumber" data-checkout="docNumber"
            v-model="customer_cpf"
            :variant="errors.length > 0 ? 'danger' : '' "
            class="w-full"
            inputmode="numeric"
            placeholder="CPF:"
            v-mask="['###.###.###-##']"
          />
          <span class="text-red-500 block pt-1" v-if="errors.length">
            <i class="bx bx-error mr-1"></i>
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
      <div class="w-full lg:w-2/4 mb-1 p-0 md:p-1 md:pb-0">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <t-input
            name="my-input"
            v-model="customer_phone"
            :variant="errors.length > 0 ? 'danger' : '' "
            class="w-full"
            inputmode="numeric"
            placeholder="Telefone:"
            v-mask="['(##) ####-####', '(##) #####-####']"
          />
          <span class="text-red-500 block pt-1" v-if="errors.length">
            <i class="bx bx-error mr-1"></i>
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    customer_name: {
      get () {
        return this.$store.state.customer_name
      },
      set (newValue) {
        this.$store.state.customer_name = newValue
      }
    },
    customer_email: {
      get () {
        return this.$store.state.customer_email
      },
      set (newValue) {
        this.$store.state.customer_email = newValue
      }
    },
    customer_cpf: {
      get () {
        return this.$store.state.customer_cpf
      },
      set (newValue) {
        this.$store.state.customer_cpf = newValue
      }
    },
    customer_phone: {
      get () {
        return this.$store.state.customer_phone
      },
      set (newValue) {
        this.$store.state.customer_phone = newValue
      }
    }
  }
}
</script>

<style>
</style>
